import { TFunction } from 'i18next'
import * as yup from 'yup'

export const schemaCreateCustomerMailerModal = (t: TFunction) =>
    yup.object().shape({
        customer_mailer_name: yup.string().required(t('blank-errors')),
        mailer_type_ids: yup
            .array()
            .of(yup.number())
            .required(t('blank-errors')),
        mailer_receiver: yup.string().required(t('blank-errors')),
        mailer_cc: yup.string(),
        mailer_bcc: yup.string(),
    })
